import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Container,
  Typography,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";

import styles, { spinnerStyles } from "./styles.styles";
import Header from "../../components/Header";
import ModalDatos from "../../components/ModalDatos";
import GrillaAdjuntos from "../../components/GrillaAdjuntos";
import GrillaSubidos from "../../components/GrillaSubidos";
import Botonera from "../../components/Botonera";
import ModalNotificacion from "../../components/ModalNotificacion";
import { getPrestador, isUploading } from "../../redux/selectors";
import SpinnerGaleno from "../../components/SpinnerGaleno";
import { desencriptarPrestador } from "../../redux/actions/operationActions";

export default () => {
  const dispatch = useDispatch();
  const classes = styles();
  const prestador = useSelector((state) => getPrestador(state));
  const subiendoArchivos = useSelector((state) => isUploading(state));

  if (!prestador) {
    if(sessionStorage.getItem('accessToken')) dispatch(desencriptarPrestador(sessionStorage.getItem('accessToken')!));
    return <SpinnerGaleno />;
  }

  return (
    <ThemeProvider theme={createMuiTheme()}>
      <Container>
        <LoadingOverlay
          active={subiendoArchivos}
          styles={spinnerStyles}
          spinner={<SpinnerGaleno />}
        >
          <Header />
          <ModalDatos />
          <Typography className={classes.title}>
            Documentación para Liquidaciones
          </Typography>
          <Typography className={classes.description}>
            Desde esta aplicación podras subir los archivos correspondientes
            para generar la Liquidación (Máximo 100mb).
          </Typography>
          <GrillaAdjuntos />
          <Botonera />
          <GrillaSubidos />
        </LoadingOverlay>
      </Container>
      <ModalNotificacion />
    </ThemeProvider>
  );
};
